/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]{color:#fff;text-decoration:none}.spacer[_ngcontent-%COMP%]{flex:1 1 auto}.right-links[_ngcontent-%COMP%]{padding-left:20px}.large-home-link[_ngcontent-%COMP%]{display:none}@media (min-width:600px){.large-home-link[_ngcontent-%COMP%]{display:inline}}"];
export { styles as styles };
